var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"sticker"}},[_c('SsButton2',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"testv__BackToTop",style:({'--sticker': `url(${_vm.currentSticker})`}),attrs:{"type":"text"},on:{"click":_vm.onClick}},[_c('i',{staticClass:"sticker"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }